import React from 'react';
import './TenantNotFound.css';

/**
 * Shown when multi-tenant resolution is enabled but no tenant was found for the current host.
 */
export default function TenantNotFound({ message, host }) {
  return (
    <div className="tenant-not-found">
      <div className="tenant-not-found__card">
        <h1 className="tenant-not-found__title">Tenant not found</h1>
        <p className="tenant-not-found__message">
          {message || 'No tenant is configured for this address.'}
        </p>
        <p className="tenant-not-found__hint">
          Use a valid tenant subdomain (e.g. tenant1.yourapp.com).
        </p>
        {host && (
          <p className="tenant-not-found__host">
            Host: <code>{host}</code>
          </p>
        )}
      </div>
    </div>
  );
}
